import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Box, Button, Link, Paper, SpeedDial, SpeedDialAction, SpeedDialIcon, Typography, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import _ from "lodash";
import moment from 'moment';
import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sticky from 'react-sticky-el/lib/basic-version';
import { DialogsContext, SessionDataContext } from "../contexts";
import StudentName from "../student/student.name";
import SubjectName from '../subject/subject.name';
import { termApi } from './term.queries';
import SubjectAvatar from '../subject/subject.avatar';

export default function TermPlanner(props) {
	const navigate = useNavigate();
	const { termId, studentId } = useParams();
	const useGet = termApi.useGet(termId);
	const term = useGet?.data;

	const theme = useTheme();
	const { dialogs } = useContext(DialogsContext);
	const sessionData = useContext(SessionDataContext);

	if (!term) {
		return;
	}

	const enrollments = _.filter(term.enrollments, enrollment => enrollment?.studentId == studentId);
	const student = enrollments[0].student;
	const subjects = _.chain(enrollments).map('course.subject').uniqBy('id').value();

	const startLabel = moment(term.startDate).format('MMMM D, YYYY');
	const endLabel = moment(term.endDate).format('MMMM D, YYYY');

	const renderEnrollment = (enrollment) => {
		const termLength = term.endDate - term.startDate;
		return (
			<Box key={enrollment.id}>
				<Stack alignItems="center">
					<SubjectAvatar subject={enrollment.course.subject} size={20}></SubjectAvatar>
					<Typography>{enrollment.course.name}</Typography>
				</Stack>
				{/* {enrollments?.length > 0 &&
					enrollments?.map(enrollment => {
						const start = term.startDate >= enrollment.startDate ? 0 : ((enrollment.startDate - term.startDate) / termLength) * 100;
						const end = term.endDate < enrollment.endDate ? 100 : ((enrollment.endDate - term.startDate) / termLength) * 100;
						const width = Math.max(end - start, 25);

						return (
							<Box key={enrollment.id} sx={{ position: 'relative', my: 2, left: start + '%', width: width + '%' }}>
								{enrollment.score > 0 && enrollment.score == maxScore && bestRibbon}
								<EnrollmentCard2 enrollment={enrollment} hideSubject={true} />
							</Box>
						);
					})
				}
				{enrollments?.length == 0 &&
					<Typography sx={{ p: 8, fontSize: '1.25rem', fontStyle: 'italic', textAlign: 'center', flex: 1, color: 'muted' }}>-- No enrollments --</Typography>
				} */}
			</Box>
		);
	};

	return (
		<Box sx={{ p: 4 }}>
			<Sticky stickyStyle={{ backgroundColor: theme.palette.background.default, zIndex: 10, top: theme.mixins.toolbar["@media (min-width:600px)"].minHeight }} topOffset={-theme.mixins.toolbar["@media (min-width:600px)"].minHeight}>
				<Stack sx={{ mb: 4 }} justifyContent="space-between" alignItems="center">
					<Typography variant="h5">{startLabel}</Typography>
					<Typography variant="h4">{term.name}</Typography>
					<Typography variant="h5">{endLabel}</Typography>
				</Stack>
			</Sticky>

			<Box>
				<Link onClick={() => navigate('/terms/' + term.id)}>
					<Stack alignItems="center">
						<KeyboardArrowLeftIcon /> Back
					</Stack>
				</Link>
				
				<Link onClick={() => navigate('/terms/' + term.id + '/students/' + student.id + '/reportCard')}>
					Report Card
				</Link>

				<Paper sx={{ height: '100%' }}>
					<Stack justifyContent="space-between" sx={{ p: 2 }}>
						<Stack alignItems="center">
							<StudentName student={student} variant="h5" hideLink={true} />
						</Stack>
					</Stack>
					<Stack direction="column" sx={{ px: 4, pb: 2 }} spacing={1}>
						{enrollments.map(enrollment => {
							return renderEnrollment(enrollment);
						})}

						<Button sx={{ alignSelf: 'start', p: 0, m: 0 }}>
							<Stack alignItems="center">
								<AddIcon />
								<Typography variant="subtitle1">Add</Typography>
							</Stack>
						</Button>
					</Stack>
				</Paper>
			</Box>

			<SpeedDial sx={{ position: 'fixed', bottom: 10, right: (sessionData.drawerOpen ? 350 : 40), alignItems: 'end', '.MuiSpeedDial-actions': { alignItems: 'end', '.MuiFab-circular': { borderRadius: 2, width: 'auto' } } }} color="primary" icon={<SpeedDialIcon />} ariaLabel="">
				<SpeedDialAction icon={<Typography sx={{ p: 2 }}>Enroll a Student</Typography>} onClick={() => dialogs.open('enrollment', { startDate: term.startDate, endDate: term.endDate })} />
				<SpeedDialAction icon={<Typography sx={{ p: 2 }}>New Term</Typography>} onClick={() => dialogs.open('term', {})} />
			</SpeedDial>
		</Box>
	);
}